<template lang="pug">
.insights-no-data(:class="widgetClass")
  img(
    v-if="imageSrc"
    :src="imageSrc"
    :alt="imageAlt"
  )
  .title
    slot(name="title")
      | {{ defaultTitle }}
  .text
    slot(name="description")
      | {{ defaultDescription }}
  slot(name="footer")
</template>

<script>
import { isNil } from 'lodash-es';
import { IMAGE_EMPTY_BOX } from '~/rails_assets';
import { INSIGHTS, INSIGHTS_ASSETS as insightsAssets } from '~/app_constants';

export default {
  name: 'InsightsNoData',
  props: {
    type: {
      type: String,
      default: 'no_data',
      validator: (v) =>
        [
          'no_data',
          'missing_network_collection',
          'tools_tracking_disabled',
          'tools_tracking_unused',
          'activity_tracking_disabled',
          'empty_description',
        ].includes(v) || isNil(v),
    },
    display: {
      type: String,
      default: 'inline',
      validator: (v) => ['inline', 'card'].includes(v) || isNil(v),
    },
  },
  computed: {
    isTypeNoData() {
      return this.type && (this.type === 'no_data' || this.type === 'empty_description');
    },
    imageSrc() {
      return this.type && !this.isTypeNoData ? insightsAssets.empty_states[this.type]?.src : IMAGE_EMPTY_BOX;
    },
    imageAlt() {
      return this.type && !this.isTypeNoData ? insightsAssets.empty_states[this.type]?.alt : null;
    },
    defaultTitle() {
      return this.type ? INSIGHTS.empty_states[this.type]?.title : INSIGHTS.empty_states.no_data.title;
    },
    defaultDescription() {
      return this.type ? INSIGHTS.empty_states[this.type]?.description : INSIGHTS.empty_states.no_data.description;
    },
    widgetClass() {
      return this.display === 'card' ? 'card' : '';
    },
  },
};
</script>
